import React from 'react';
import { useSparks } from '../../contexts/SparksContext';
import AddyAvatar from '../Sparks/AddyAvatar';
import { useShop } from '../Sparks/useCosmeticCatalogue';

/**
 * Addy in the child's own outfit with a speech bubble. The page changes `message` as the child hovers and
 * picks things: Addy talks while a hover line is showing and cheers when a lesson starts.
 */
export default function AddyGuide({ childId, message, talking = false, celebrating = false }) {
  const { equipped } = useSparks();
  const shop = useShop(childId);
  return (
    <div className="flex items-center gap-2" data-testid="addy-guide">
      <div className="shrink-0">
        <AddyAvatar equipped={equipped} catalogue={shop?.items} size={88} mood={talking ? 'talking' : 'sway'} celebrating={celebrating} />
      </div>
      <p
        key={message}
        aria-live="polite"
        className="relative max-w-[16rem] rounded-2xl bg-white px-4 py-3 text-sm font-semibold text-[#2F1E6B] shadow-md animate-in fade-in zoom-in-95 duration-200 motion-reduce:animate-none before:absolute before:-left-2 before:top-1/2 before:-translate-y-1/2 before:border-y-8 before:border-r-8 before:border-y-transparent before:border-r-white"
        data-testid="addy-message"
      >
        {message}
      </p>
    </div>
  );
}
